'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowAssets = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _semanticUiReact = require('semantic-ui-react');

var _reactCsv = require('react-csv');

var _formatting = require('../../utils/formatting');

var _currencies = require('../../utils/currencies');

var _emvUtils = require('../../utils/emv-utils');

var _shopify = require('../../shopify.svg');

var _shopify2 = _interopRequireDefault(_shopify);

var _dyzioIcons = require('../../components/dyzio-icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var averageRowStyle = {
  background: '#EEE'
};

var textBoldStyle = {
  fontWeight: 'bold'
};

var shopifyLogoStyle = {
  width: '2em',
  margin: 'auto'
};

var insightsLogoStyle = {
  'font-size': '2em',
  color: '#e03997',
  margin: 'auto'
};

var hasNoAssets = function hasNoAssets(array) {
  return _lodash2.default.isUndefined(_lodash2.default.find(array, function (i) {
    return i > 0;
  }));
};

var tableStyle = { marginBottom: 0 };
var boldFontStyle = { fontWeight: 'bold' };
var avatarStyle = {
  width: 50,
  height: 50,
  float: 'left'
};

var influencerNameStyle = {
  fontSize: 16,
  marginLeft: 8,
  marginBottom: -4,
  marginTop: 4,
  float: 'left'
};

var influnecerHandleStyle = {
  marginLeft: 8,
  fontSize: '90%',
  marginTop: 3,
  float: 'left',
  color: 'gray'
};

var HELP_LINK = 'https://help.dyzio.co/campaign-reports/roi-report';
var goToHelpPage = function goToHelpPage() {
  return window.open(HELP_LINK, '_blank');
};

var hostname = _lodash2.default.toLower(window.location.hostname);
var isVoxogram = hostname.match(/voxogram/);

var getShopifyTotals = function getShopifyTotals(_ref) {
  var rows = _ref.rows;

  var totalOrders = _lodash2.default.reduce(rows, function (acc, row) {
    var shopifyOrders = row.shopifyOrders;

    return acc + (shopifyOrders ? shopifyOrders.length : 0);
  }, 0);

  var totalSales = _lodash2.default.reduce(rows, function (acc, row) {
    var shopifyOrders = row.shopifyOrders;

    return acc + (shopifyOrders ? _lodash2.default.sumBy(shopifyOrders, 'orderTotal') : 0);
  }, 0);

  var totalCommission = _lodash2.default.reduce(rows, function (acc, row) {
    var shopifyOrders = row.shopifyOrders;

    return acc + (shopifyOrders ? _lodash2.default.sumBy(shopifyOrders, 'orderCommission') : 0);
  }, 0);

  return {
    totalCommission: totalCommission,
    totalOrders: totalOrders,
    totalSales: totalSales
  };
};

var TotalsRow = function TotalsRow(_ref2) {
  var rows = _ref2.rows,
      currency = _ref2.currency;

  var totalBudget = _lodash2.default.sumBy(_lodash2.default.values(rows), function (row) {
    var inventoryItemsValues = _lodash2.default.sumBy(_lodash2.default.get(row, 'inventoryItems', []), 'monetaryValue');
    return (inventoryItemsValues ? inventoryItemsValues : 0) + _lodash2.default.get(row, 'budget', 0);
  });
  var reachTotal = _lodash2.default.sumBy(_lodash2.default.values(rows), function (row) {
    return _lodash2.default.get(row, 'totals.reach');
  });
  var impressionsTotal = _lodash2.default.sumBy(_lodash2.default.values(rows), function (row) {
    return _lodash2.default.get(row, 'totals.impressions');
  });
  var engagementsTotal = _lodash2.default.sumBy(_lodash2.default.values(rows), function (row) {
    return _lodash2.default.get(row, 'totals.engagements');
  });
  var videoViewsTotal = _lodash2.default.sumBy(_lodash2.default.values(rows), function (row) {
    return _lodash2.default.get(row, 'totals.videoViews');
  });

  var _getShopifyTotals = getShopifyTotals({ rows: rows }),
      totalCommission = _getShopifyTotals.totalCommission,
      totalOrders = _getShopifyTotals.totalOrders,
      totalSales = _getShopifyTotals.totalSales;

  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    { textAlign: 'center', style: boldFontStyle },
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'left' },
      _react2.default.createElement(
        'b',
        null,
        'Totals/Averages'
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          totalBudget >= 1 ? '' + (0, _formatting.priceFormatted)(totalBudget) : '-'
        ),
        content: 'currency: ' + currency
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          (0, _formatting.commaFormatted)(reachTotal)
        ),
        content: 'Sum of total reach'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          (0, _formatting.commaFormatted)(impressionsTotal)
        ),
        content: 'Sum of total impressions'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          (0, _formatting.commaFormatted)(videoViewsTotal)
        ),
        content: 'Sum of total views'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          (0, _formatting.commaFormatted)(engagementsTotal)
        ),
        content: 'Sum of total engagements'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { style: averageRowStyle },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          (0, _formatting.commaFormatted)(totalOrders)
        ),
        content: 'currency: ' + currency
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { style: averageRowStyle },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          (0, _formatting.commaFormatted)(totalSales)
        ),
        content: 'currency: ' + currency
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { style: averageRowStyle },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          (0, _formatting.commaFormatted)(totalCommission)
        ),
        content: 'currency: ' + currency
      })
    )
  );
};

var RowAssets = exports.RowAssets = function RowAssets(_ref3) {
  var facebook = _ref3.facebook,
      twitter = _ref3.twitter,
      instagram = _ref3.instagram,
      youtube = _ref3.youtube,
      tiktok = _ref3.tiktok;

  var noAssets = hasNoAssets([facebook.count, instagram.images, instagram.videos, instagram.stories, instagram.carousels, instagram.igtvs, twitter.count, youtube.count, tiktok.count]);
  var tiktokIconStyle = {
    marginLeft: 0,
    marginTop: 0,
    marginBottom: 0,
    marginRight: 2
  };
  return _react2.default.createElement(
    _semanticUiReact.List,
    null,
    noAssets && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      '-'
    ),
    facebook && facebook.count > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      facebook.count,
      ' x ',
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook' }),
      ' POST '
    ),
    instagram && instagram.images > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      instagram.images,
      ' x ',
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
      ' POST '
    ),
    instagram && instagram.videos > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      instagram.videos,
      ' x ',
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
      ' VIDEO '
    ),
    instagram && instagram.stories > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      instagram.stories,
      ' x ',
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
      ' STORY '
    ),
    instagram && instagram.carousels > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      instagram.carousels,
      ' x ',
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
      ' CAROUSEL '
    ),
    instagram && instagram.igtvs > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      instagram.igtvs,
      ' x ',
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
      ' IGTV '
    ),
    twitter && twitter.count > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      twitter.count,
      ' x ',
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'twitter' }),
      ' TWEET '
    ),
    youtube && youtube.count > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      youtube.count,
      ' x ',
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube' }),
      ' VIDEO '
    ),
    tiktok && tiktok.count > 0 && _react2.default.createElement(
      _semanticUiReact.List.Item,
      null,
      tiktok.count,
      ' x ',
      _react2.default.createElement(_dyzioIcons.TiktokIcon, { additionalStyles: tiktokIconStyle }),
      '  VIDEO '
    )
  );
};

RowAssets.propTypes = {
  youtube: _propTypes2.default.object.isRequired,
  instagram: _propTypes2.default.object.isRequired,
  facebook: _propTypes2.default.object.isRequired,
  twitter: _propTypes2.default.object.isRequired,
  tiktok: _propTypes2.default.object.isRequired
};

var twoRowsModeArrowStyle = {
  color: 'gray',
  display: 'block',
  float: 'right',
  marginLeft: -22,
  marginTop: -3,
  marginRight: -10
};

var oneRowModeArrowStyle = (0, _extends3.default)({}, twoRowsModeArrowStyle, {
  marginTop: 3
});

var SortArrow = function SortArrow(_ref4) {
  var field = _ref4.field,
      order = _ref4.order,
      targetField = _ref4.targetField,
      twoRowsMode = _ref4.twoRowsMode;

  var shouldRenderIcon = _lodash2.default.eq(field, targetField);
  if (shouldRenderIcon) {
    return _react2.default.createElement(_semanticUiReact.Icon, {
      name: 'angle ' + (order === 'asc' ? 'up' : 'down'),
      style: twoRowsMode ? twoRowsModeArrowStyle : oneRowModeArrowStyle,
      size: 'small'
    });
  }
  return null;
};

SortArrow.propTypes = {
  field: _propTypes2.default.string.isRequired,
  order: _propTypes2.default.oneOf(['asc', 'desc']).isRequired,
  targetField: _propTypes2.default.string.isRequired,
  twoRowsMode: _propTypes2.default.boolean
};

SortArrow.defaultProps = {
  twoRowsMode: false
};

var ReportTableHeader = function ReportTableHeader(_ref5) {
  var onSortChanged = _ref5.onSortChanged,
      sort = _ref5.sort,
      currency = _ref5.currency;
  return _react2.default.createElement(
    _semanticUiReact.Table.Header,
    null,
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('name');
        }
      },
      'influencer ',
      _react2.default.createElement(SortArrow, (0, _extends3.default)({ targetField: 'name' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('trackedAssetsStats.totalAssets');
        }
      },
      'assets ',
      _react2.default.createElement(SortArrow, (0, _extends3.default)({ targetField: 'trackedAssetsStats.totalAssets' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('totals.reach');
        },
        textAlign: 'center'
      },
      'total ',
      _react2.default.createElement('br', null),
      'reach ',
      _react2.default.createElement(SortArrow, (0, _extends3.default)({ twoRowsMode: true, targetField: 'totals.reach' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('totals.impressions');
        },
        textAlign: 'center'
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'total ',
          _react2.default.createElement('br', null),
          'imps',
          _react2.default.createElement(SortArrow, (0, _extends3.default)({ twoRowsMode: true, targetField: 'totals.impressions' }, sort))
        ),
        content: 'total impressions'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('totals.videoViews');
        },
        textAlign: 'center'
      },
      'video ',
      _react2.default.createElement('br', null),
      'views ',
      _react2.default.createElement(SortArrow, (0, _extends3.default)({ twoRowsMode: true, targetField: 'totals.videoViews' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('totals.engagements');
        },
        textAlign: 'center'
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'total ',
          _react2.default.createElement('br', null),
          'engs ',
          _react2.default.createElement(SortArrow, (0, _extends3.default)({ twoRowsMode: true, targetField: 'totals.engagements' }, sort))
        ),
        content: _react2.default.createElement(
          'span',
          null,
          'total engagements:',
          _react2.default.createElement('br', null),
          ' likes + comments'
        )
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        textAlign: 'center'
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'TOTAL',
          _react2.default.createElement('br', null),
          'ORDERS'
        ),
        content: 'currency: ' + currency
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        textAlign: 'center'
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'TOTAL',
          _react2.default.createElement('br', null),
          'SALES'
        ),
        content: 'currency: ' + currency
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        textAlign: 'center'
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'TOTAL',
          _react2.default.createElement('br', null),
          'COMMISSION'
        ),
        content: 'currency: ' + currency
      })
    )
  );
};

ReportTableHeader.propTypes = {
  onSortChanged: _propTypes2.default.func.isRequired
};

var fluidStyle = { width: '100%' };

var ReportRow = function ReportRow(_ref6) {
  var id = _ref6.id,
      name = _ref6.name,
      thumbnail = _ref6.thumbnail,
      influencerName = _ref6.influencerName,
      paypalEmail = _ref6.paypalEmail,
      budget = _ref6.budget,
      derivedFee = _ref6.derivedFee,
      _ref6$inventoryItems = _ref6.inventoryItems,
      inventoryItems = _ref6$inventoryItems === undefined ? [] : _ref6$inventoryItems,
      currency = _ref6.currency,
      _ref6$totals = _ref6.totals,
      reach = _ref6$totals.reach,
      impressions = _ref6$totals.impressions,
      engagements = _ref6$totals.engagements,
      videoViews = _ref6$totals.videoViews,
      _ref6$costs = _ref6.costs,
      costPerEngagement = _ref6$costs.costPerEngagement,
      impressionsCPM = _ref6$costs.impressionsCPM,
      reachCPM = _ref6$costs.reachCPM,
      viewsCPM = _ref6$costs.viewsCPM,
      engsCPM = _ref6$costs.engsCPM,
      trackedAssetsStats = _ref6.trackedAssetsStats,
      shopifyOrders = _ref6.shopifyOrders,
      shopifyDiscountCode = _ref6.shopifyDiscountCode;
  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    { key: id },
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Image, {
        src: thumbnail,
        className: 'circular',
        style: avatarStyle
      }),
      _react2.default.createElement(
        'span',
        { style: influencerNameStyle },
        influencerName
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'span',
        { style: influnecerHandleStyle },
        _react2.default.createElement(_semanticUiReact.Popup, {
          content: 'Shopify discount code',
          trigger: _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'code' }),
            shopifyDiscountCode
          )
        })
      ),
      _react2.default.createElement(
        'div',
        { style: { clear: 'left', paddingTop: 10 } },
        paypalEmail && _react2.default.createElement(_semanticUiReact.Popup, {
          content: 'PayPal email for payouts: ' + paypalEmail,
          trigger: _react2.default.createElement(
            _semanticUiReact.Label,
            { basic: true, color: 'blue' },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'paypal', color: 'blue' }),
            paypalEmail
          )
        })
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(RowAssets, trackedAssetsStats)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      reach ? (0, _formatting.commaFormatted)(reach) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      impressions ? (0, _formatting.commaFormatted)(impressions) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      videoViews ? (0, _formatting.commaFormatted)(videoViews) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      engagements ? (0, _formatting.commaFormatted)(engagements) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      _lodash2.default.isEmpty(shopifyOrders) ? '-' : _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          (0, _formatting.commaFormatted)(shopifyOrders.length)
        ),
        content: 'currency: ' + currency
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      _lodash2.default.isEmpty(shopifyOrders) ? '-' : _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          '\xA3',
          (0, _formatting.commaFormatted)(_lodash2.default.sumBy(shopifyOrders, 'orderTotal'))
        ),
        content: 'currency: ' + currency
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      _lodash2.default.isEmpty(shopifyOrders) ? '-' : _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          '\xA3',
          (0, _formatting.priceFormatted)(_lodash2.default.sumBy(shopifyOrders, 'orderCommission'))
        ),
        content: 'currency: ' + currency
      })
    )
  );
};

ReportRow.propTypes = {
  id: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  budget: _propTypes2.default.any.isRequired,
  currency: _propTypes2.default.string.isRequired,
  totals: _propTypes2.default.object.isRequired,
  costs: _propTypes2.default.object.isRequired,
  trackedAssetsStats: _propTypes2.default.object.isRequired,
  thumbnail: _propTypes2.default.string.isRequired,
  inventoryItems: _propTypes2.default.array.isRequired,
  influencerName: _propTypes2.default.string.isRequired
};

var reverseOrder = function reverseOrder() {
  var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'asc';

  if (order === 'asc') {
    return 'desc';
  }
  return 'asc';
};

var ROIReport = function (_Component) {
  (0, _inherits3.default)(ROIReport, _Component);

  function ROIReport(props) {
    (0, _classCallCheck3.default)(this, ROIReport);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ROIReport.__proto__ || (0, _getPrototypeOf2.default)(ROIReport)).call(this, props));

    _this.onSortFieldChange = function (field) {
      _this.setState({
        sort: {
          field: field,
          order: reverseOrder(_this.state.sort.order)
        }
      });
    };

    _this.getInsightsIcon = function () {
      return _react2.default.createElement(_semanticUiReact.Icon, {
        style: insightsLogoStyle,
        name: 'line graph'
      });
    };

    _this.getShopifyIcon = function () {
      return _react2.default.createElement('img', {
        style: shopifyLogoStyle,
        src: _shopify2.default,
        alt: 'Shopify'
      });
    };

    _this.state = {
      sort: {
        field: 'costs.costPerEngagement',
        order: 'asc'
      }
    };
    return _this;
  }

  (0, _createClass3.default)(ROIReport, [{
    key: 'render',
    value: function render() {
      var sort = this.state.sort;
      var _props = this.props,
          campaignName = _props.campaignName,
          currency = _props.currency,
          reportData = _props.reportData,
          onFilterChange = _props.onFilterChange,
          filter = _props.filter;


      var isEmptyReport = _lodash2.default.isEmpty(reportData);

      var reportRows = reportData;
      var isFiltered = false;

      if (_lodash2.default.get(filter, 'basic.handle', false)) {
        isFiltered = true;
        reportRows = _lodash2.default.filter(reportRows, ['name', _lodash2.default.get(filter, 'basic.handle')]);
      }

      var csvValues = _lodash2.default.map(reportRows, function (item) {
        return {

          // General fields
          influencer: _lodash2.default.get(item, 'name', '-'),
          fee: _lodash2.default.get(item, 'budget', '-'),
          currency: currency,
          tiktokVideos: _lodash2.default.get(item, 'trackedAssetsState.tiktok.count', 0),
          instagramPosts: _lodash2.default.get(item, 'trackedAssetsStats.instagram.images', 0),
          instagramVideos: _lodash2.default.get(item, 'trackedAssetsStats.instagram.videos', 0),
          instagramStories: _lodash2.default.get(item, 'trackedAssetsStats.instagram.stories', 0),
          instagramIGTVs: _lodash2.default.get(item, 'trackedAssetsStats.instagram.igtvs', 0),
          youtubeVideos: _lodash2.default.get(item, 'trackedAssetsStats.youtube.count', 0),
          facebookPosts: _lodash2.default.get(item, 'trackedAssetsStats.facebook.count', 0),
          twitterPosts: _lodash2.default.get(item, 'trackedAssetsStats.twitter.count', 0),
          reach: _lodash2.default.get(item, 'totals.reach', 0),
          impressions: _lodash2.default.get(item, 'totals.impressions', 0),
          videoViews: _lodash2.default.get(item, 'totals.videoViews', 0),
          engagements: _lodash2.default.get(item, 'totals.engagements', 0),
          reachCPM: _lodash2.default.get(item, 'costs.reachCPM', 0),
          impressionsCPM: _lodash2.default.get(item, 'costs.impressionsCPM', 0),
          viewsCPM: _lodash2.default.get(item, 'costs.viewsCPM', 0),
          engsCPM: _lodash2.default.get(item, 'costs.engsCPM', 0)

        };
      });

      var timestamp = (0, _moment2.default)().format('YYYY-MM-DD');
      var influencerNames = _lodash2.default.map(reportData, 'name');
      var csvFileName = _lodash2.default.kebabCase(campaignName) + '-roi-' + timestamp + '.csv';

      var reportRowsWithCommission = _lodash2.default.map(reportRows, function (rr) {
        return (0, _extends3.default)({}, rr, {
          commission: _lodash2.default.sumBy(rr.shopifyOrders, 'orderCommission')
        });
      });

      var sortedReportRows = _lodash2.default.orderBy(reportRowsWithCommission, ['commission'], ['desc']);

      console.log(sortedReportRows);

      var totals = (0, _emvUtils.getTotals)(reportRows);

      var _getShopifyTotals2 = getShopifyTotals({ rows: reportRows }),
          totalCommission = _getShopifyTotals2.totalCommission,
          totalSales = _getShopifyTotals2.totalSales,
          totalOrders = _getShopifyTotals2.totalOrders;

      var totalItems = [{ color: 'pink', key: 'insights', label: 'insights', value: this.getInsightsIcon() }, { key: 'views', label: 'Views', value: (0, _formatting.paidReportFormat)(totals.videoViewsTotal) }, { key: 'reach', label: 'Reach', value: (0, _formatting.paidReportFormat)(totals.reachTotal) }, { key: 'impressions', label: 'Impressions', value: (0, _formatting.paidReportFormat)(totals.impressionsTotal) }, { key: 'engagements', label: 'Engagements', value: (0, _formatting.paidReportFormat)(totals.engagementsTotal) }];

      var totalShopifyItems = [{ key: 'shopify', label: 'shopify', value: this.getShopifyIcon() }, { key: 'currency', label: 'currency', value: currency }, { color: 'pink', key: 'orders', label: 'orders', value: (0, _formatting.paidReportFormat)(totalOrders) }, { color: 'pink', key: 'sales', label: 'shopify sales', value: '\xA3' + (0, _formatting.paidReportFormat)(totalSales) }, { color: 'pink', key: 'commission', label: 'shopify commission', value: '\xA3' + (0, _formatting.paidReportFormat)(totalCommission) }];

      return _react2.default.createElement(
        'div',
        null,
        isEmptyReport && _react2.default.createElement(_semanticUiReact.Message, null),
        !isEmptyReport && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _semanticUiReact.Segment,
            null,
            _react2.default.createElement(_semanticUiReact.Statistic.Group, { size: 'tiny', widths: 'five', items: totalItems })
          ),
          _react2.default.createElement(
            _semanticUiReact.Segment,
            null,
            _react2.default.createElement(_semanticUiReact.Statistic.Group, { size: 'tiny', widths: 'five', items: totalShopifyItems })
          ),
          _react2.default.createElement(
            _semanticUiReact.Menu,
            null,
            _react2.default.createElement(
              _semanticUiReact.Menu.Menu,
              null,
              _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'FILTER BY:'
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Menu.Menu,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dropdown,
                { scrolling: true, item: true, text: isFiltered ? filter.basic.handle : 'influencer' },
                _react2.default.createElement(
                  _semanticUiReact.Dropdown.Menu,
                  null,
                  isFiltered && _react2.default.createElement(
                    _semanticUiReact.Dropdown.Item,
                    {
                      onClick: function onClick(event) {
                        return onFilterChange(event, { value: 'handle.reset' });
                      },
                      value: 'discussion.reset'
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', size: 'tiny' }),
                    'reset'
                  ),
                  _lodash2.default.map(influencerNames, function (name) {
                    return _react2.default.createElement(
                      _semanticUiReact.Dropdown.Item,
                      {
                        onClick: function onClick(event) {
                          return onFilterChange(event, { value: 'handle.' + name });
                        },
                        value: 'discussion'
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'user', size: 'tiny' }),
                      ' ',
                      _lodash2.default.toLower(name)
                    );
                  })
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Menu.Item,
              { position: 'right' },
              _react2.default.createElement(
                _semanticUiReact.Label,
                { basic: true, size: 'large', color: 'pink' },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel outline' }),
                _react2.default.createElement(
                  _reactCsv.CSVLink,
                  { data: csvValues, filename: csvFileName },
                  'Download Report'
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Menu.Item,
              null,
              !isVoxogram && _react2.default.createElement(_semanticUiReact.Button, { color: 'pink', inverted: true, size: 'tiny', circular: true, icon: 'help', onClick: goToHelpPage })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Card,
            { fluid: true, color: 'green' },
            _react2.default.createElement(
              _semanticUiReact.Table,
              { sortable: true, basic: 'very', singleLine: true, celled: true, style: tableStyle },
              _react2.default.createElement(ReportTableHeader, {
                onSortChanged: this.onSortFieldChange,
                sort: sort,
                currency: currency
              }),
              _react2.default.createElement(
                _semanticUiReact.Table.Body,
                null,
                _lodash2.default.map(sortedReportRows, function (row) {
                  return _react2.default.createElement(ReportRow, (0, _extends3.default)({ key: (0, _uuid2.default)() }, row, { currency: currency }));
                }),
                _react2.default.createElement(TotalsRow, { rows: reportRows, currency: currency })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Card.Content,
              { extra: true },
              _react2.default.createElement(
                'div',
                { className: 'ui right aligned' },
                'Report generated at ',
                _react2.default.createElement(
                  'strong',
                  null,
                  (0, _moment2.default)().format('MMMM Do YYYY, h:mm a')
                ),
                '.'
              )
            )
          )
        )
      );
    }
  }]);
  return ROIReport;
}(_react.Component);

ROIReport.propTypes = {
  onFilterChange: _propTypes2.default.func,
  campaignName: _propTypes2.default.string.isRequired,
  currency: _propTypes2.default.string.isRequired,
  filter: _propTypes2.default.object.isRequired,
  reportData: _propTypes2.default.object.isRequired
};

ROIReport.defaultProps = {
  onFilterChange: _lodash2.default.noop
};

exports.default = ROIReport;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/shopify-report/index.js
// module id = 2162
// module chunks = 1